module.exports = __webpack_public_path__ + "static/media/448.09a76bb7.webp";